import React, { lazy, useState } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router";
import MainForm from "./pages/MainForm/MainForm";
import MainImport from "./pages/MainImport/MainImport";
import CSVFileUploader from "./pages/CSVFileUploader";
import Login from "./pages/Login/Login";
import { useEffect } from "react";
import Logout from "./pages/Logout/Logout";
import { Global_Data } from "./globalData/GlobalData";

import Spinner from "./component/spinner/Spinner";
import axios from "axios";
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { blue } from "@mui/material/colors";
import useOnlineStatus from "./pages/hooks/useOnlineStatus";
import CustomAlert from "./component/AlertComponent/Alert";
import SSEInfoAlert from "./component/AlertComponent/SSEInfoAlert";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import TwoFaRequired from "./pages/Login/TwoFaRequired";
import SseMonitor from "./pages/SseMonitor/SseMonitor";
const SideDrawer = lazy(() => import("./layout/MainLayout/SideDrawer"));
const TestApi = lazy(() => import("./pages/testApi/TestApi"));
import { LicenseInfo } from '@mui/x-license';
const ReportDesigner = lazy(() => import("./pages/reports/ReportDesigner"));

LicenseInfo.setLicenseKey('6d094e6e4a86c1aea20a351bcf440daaTz0xMjU3NTEsRT0xODAyOTA4Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

function App() {
  const { sideBarStyle,isPageLoading ,formData, token } = Global_Data?.() || {};
  const navigate = useNavigate();
  const location = useLocation();
  const isOnline = useOnlineStatus();

  const [fetchmainApi, setFetchMainApi] = useState(null);


  

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/login");
    }
  }, [location.pathname]);

  useEffect(() => {

// alert(JSON.stringify(isOnline))
if (!isOnline) {
  CustomAlert("error", "The system cannot connect to the back-end", {
    domain: "connection",
    action: "backend"
  });
}

  },[isOnline])

  return (
    <>
    {isOnline}
      <SSEInfoAlert
        enabled={["/login", "/resetpassword", "/twofa", "/sse-monitor"].some(path =>
          location.pathname.startsWith(path)
        )}
      />
   
      {/* {JSON.stringify(theamStyle)} */}
      {/* <ThemeProvider theme={theamStyle}> */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/twofa" element={<TwoFaRequired />} />
          <Route path="/sse-monitor" element={<SseMonitor />} />

          <Route path="/user/logout" element={<Logout />} />
          <Route
            path="/*"
            element={
              sideBarStyle && typeof sideBarStyle === 'object' ? (
                <NestedRoute fetchmainApi={fetchmainApi} setFetchMainApi={setFetchMainApi} />
              ) : (
                <div style={{height:'100vh',width:"100vw",display:'flex',justifyContent:"center",alignItems:"center",}}>
               <div>
               <Spinner />
               </div>
                </div>
              )
            }
          />
        </Routes>
      {/* </ThemeProvider> */}
    </>
  );
}

const NestedRoute = ({ fetchmainApi, setFetchMainApi }) => {
  return (
    <SideDrawer fetchmainApi={fetchmainApi}>
      <Routes>
        <Route path="/testapi" element={<TestApi />} />
        <Route path="/sse-monitor" element={<SseMonitor />} />

        <Route
          path="/settings/reports/designer"
          element={<ReportDesigner />}
        />

        <Route path="/import" element={<MainImport />} />
        <Route path="/csv" element={<CSVFileUploader />} />

        <Route path="/*" element={<MainForm setFetchMainApi={setFetchMainApi} />} />
      </Routes>
    </SideDrawer>
  );
};
export default App;
